import type { RouteRecordRaw } from 'vue-router'

import { useHome } from '@/composables/useHome'
import AboutPopup from '@/modules/About.vue'
import Beepers from '@/modules/beepers/Beepers.vue'
import BlockVersion from '@/modules/BlockVersion.vue'
import Checkout from '@/modules/checkout/Checkout.vue'
import CouriersReport from '@/modules/couriers-report/CouriersReport.vue'
import CloseDelivery from '@/modules/delivery/CloseDelivery.vue'
import EmployeeSelector from '@/modules/employees/EmployeeSelector.vue'
import TableTabs from '@/modules/floorplan/TableTabs.vue'
import HardwareSelector from '@/modules/hardware-selector/HardwareSelector.vue'
import Home from '@/modules/Home.vue'
import MenuAvailability from '@/modules/menu-availability/MenuAvailability.vue'
import FreeTrialExpired from '@/modules/onboarding/FreeTrialExpired.vue'
import GracePeriodExpired from '@/modules/onboarding/GracePeriodExpired.vue'
import LocationSelector from '@/modules/onboarding/LocationSelector.vue'
import Login from '@/modules/onboarding/Login.vue'
import NewPassword from '@/modules/onboarding/NewPassword.vue'
import OverTheLimit from '@/modules/onboarding/OverTheLimit.vue'
import RedirectLogin from '@/modules/onboarding/RedirectLogin.vue'
import SupportLogin from '@/modules/onboarding/SupportLogin.vue'
import OrderManagement from '@/modules/ordering/OrderManagement.vue'
import Printers from '@/modules/printers/Printers.vue'
import RealTimeReport from '@/modules/reports/RealTimeReport.vue'
import LinkReservations from '@/modules/reservations/LinkReservations.vue'
import Reservations from '@/modules/reservations/Reservations.vue'
import ReservationsList from '@/modules/reservations/ReservationsList.vue'
import Timeline from '@/modules/reservations/Timeline.vue'
import SearchView from '@/modules/search/SearchView.vue'
import EndShift from '@/modules/shift/EndShift.vue'
import PayInPayOut from '@/modules/shift/PayInPayOut.vue'
import StartShift from '@/modules/shift/StartShift.vue'
import TabBrowser from '@/modules/tabs/TabBrowser.vue'
import WrongTime from '@/modules/WrongTime.vue'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'employees' }
  },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'newPassword',
    path: '/new-password/:recoverId?/:token?',
    component: NewPassword
  },
  {
    name: 'locations',
    path: '/locations',
    component: LocationSelector
  },
  {
    name: 'redirectLogin',
    path: '/redirect-login',
    component: RedirectLogin
  },
  {
    name: 'supportLogin',
    path: '/support-login',
    component: SupportLogin
  },
  {
    name: 'employees',
    path: '/employees',
    component: EmployeeSelector
  },
  {
    name: 'pos',
    path: '/pos',
    component: Home,
    redirect() {
      const { checkRedirect } = useHome()
      return checkRedirect()
    },
    children: [
      {
        name: 'floorplan',
        path: 'floorplan',
        component: TableTabs
      },
      {
        name: 'delivery',
        path: 'delivery',
        component: TabBrowser,
        props: {
          tabsType: 'delivery'
        }
      },
      {
        name: 'takeAway',
        path: 'takeAway',
        component: TabBrowser,
        props: {
          tabsType: 'takeAway'
        }
      },
      {
        name: 'tabs',
        path: 'tabs',
        component: TabBrowser,
        props: {
          tabsType: 'all'
        }
      },
      {
        name: 'fastMode',
        path: 'fast-mode',
        component: OrderManagement
      },
      {
        name: 'reservations',
        path: 'reservations',
        component: Reservations,
        redirect: { name: 'reservationsList' },
        children: [
          {
            name: 'reservationsList',
            path: 'list',
            component: ReservationsList
          },
          {
            name: 'reservationsTimeline',
            path: 'timeline',
            component: Timeline
          }
        ]
      }
    ]
  },
  {
    name: 'linkReservations',
    path: '/reservations',
    component: LinkReservations
  },
  {
    name: 'orderManagement',
    path: '/pos/order-management/:tabId',
    strict: true,
    component: OrderManagement
  },
  {
    name: 'checkout',
    path: '/pos/order-management/:tabId/checkout',
    component: Checkout
  },
  {
    name: 'startShift',
    path: '/start-shift',
    component: StartShift
  },
  {
    name: 'endShift',
    path: '/end-shift',
    component: EndShift
  },
  {
    name: 'realTimeReport',
    path: '/real-time-report',
    component: RealTimeReport
  },
  {
    name: 'couriersReport',
    path: '/couriers-report',
    component: CouriersReport
  },
  {
    name: 'search',
    path: '/search',
    component: SearchView
  },
  {
    name: 'payInPayOut',
    path: '/pay-in-pay-out',
    component: PayInPayOut
  },
  {
    name: 'products',
    path: '/products',
    component: MenuAvailability
  },
  {
    name: 'closeDelivery',
    path: '/close-delivery',
    component: CloseDelivery
  },
  {
    name: 'hardwareSelector',
    path: '/hardware-selector',
    component: HardwareSelector
  },
  {
    name: 'beepers',
    path: '/beepers',
    component: Beepers
  },
  {
    name: 'printers',
    path: '/printers',
    component: Printers
  },
  {
    name: 'overTheLimit',
    path: '/over-the-limit',
    component: OverTheLimit
  },
  {
    name: 'freeTrialExpired',
    path: '/free-trial-expired',
    component: FreeTrialExpired
  },
  {
    name: 'gracePeriodExpired',
    path: '/grace-period-expired',
    component: GracePeriodExpired
  },
  {
    name: 'wrongTime',
    path: '/wrong-time',
    component: WrongTime
  },
  {
    name: 'updateDevice',
    path: '/update-device',
    component: BlockVersion
  },
  {
    name: 'about',
    path: '/about',
    component: AboutPopup
  }
]
